import { render, staticRenderFns } from "./PorcetageCardComponent.vue?vue&type=template&id=36710412&scoped=true"
import script from "./PorcetageCardComponent.vue?vue&type=script&lang=js"
export * from "./PorcetageCardComponent.vue?vue&type=script&lang=js"
import style0 from "./PorcetageCardComponent.vue?vue&type=style&index=0&id=36710412&prod&scoped=true&lang=css"
import style1 from "@/other/assets/css/app.css?vue&type=style&index=1&id=36710412&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36710412",
  null
  
)

export default component.exports